import { Box, Typography } from '@mui/material'

export const Finish = () => {
  return (
    <Box textAlign="center" p={4}>
      <Typography>配達完了メッセージを送信しました。</Typography>
      <Typography>ご苦労様でした。</Typography>
    </Box>
  )
}
